/* eslint-disable func-style */
/* eslint-disable max-lines-per-function */
/**
 *+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
 *|q|u|a|n|t|i|f|y|
 *+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
 *
 * This extension allows for the use of buttons to increase/decrease item
 * quantities on the product and basket pages. When used on the basket page,
 * the decrease button becomes a remove button if the quantity is 1.
 */

(function () {
	'use strict';

	var adjusters = document.querySelectorAll('[data-hook="wishlist-quantify"]');

	for (var id = 0; id < adjusters.length; id++) {

		/**
		 * This listener prevents the `enter` key from adjusting the `input` value.
		 */
		adjusters[id].addEventListener('keydown', function (keyEvent) {
			if (keyEvent.target.matches('input')) {
				if (keyEvent.key === 'Enter') {
					keyEvent.preventDefault();
				}
			}
		});

		adjusters[id].addEventListener('click', function (event) {
			if (event.target.matches('button')) {
				var button = event.target;
				var inputs = [].filter.call(this.children, function (sibling) {
					return sibling !== button && sibling.matches('input');
				});
				var input = inputs[0];
				var value = parseInt(input.value, 10);
				var action = button.getAttribute('data-action');
				var changed = document.createEvent('HTMLEvents');

				changed.initEvent('change', true, false);
				event.stopPropagation();
				event.preventDefault();

				if (action === 'decrement') {

					/**
					 * THIS CAN BE USED TO SET A MINIMUM QUANTITY
					 * value = value > 5 ? value - 1 : 5;
					 */
					value = value > 1 ? value - 1 : 1;

					input.value = value;
					input.dispatchEvent(changed);
				} else if (action === 'increment') {

					/**
					 * THIS CAN BE USED TO SET A MAXIMUM QUANTITY
					 * value = value < 100 ? value + 1 : 100;
					 */
					value += 1;

					input.value = value;
					input.dispatchEvent(changed);

				} else {
					input.value = 0;
					input.dispatchEvent(changed);
				}
			}
		});
	}
}());
